export enum DataPolicy {
  /**
   * These values map directly to the Enum values defined in DataPolicy.scala in
   * the iterable repo.
   */
  // TODO: Confirm that the Create Org request accepts these values
  UNRESTRICTED = 'Unrestricted',
  HIPAA = 'Hipaa',
}
